module.exports = __webpack_public_path__ + "img/voucher.b43db4ec.svg";